import React, { useContext, PropsWithChildren } from "react";
import { ListContext, IntlContext } from "context";
import Toolbar from "./Toolbar";
import { Backdrop, Loader } from "ui/Loader";
import { cn } from "lib/utils";

interface Props {
    ToolBarComponent?: React.FC;
    noResultsLabel?: React.ReactNode;
    emptyStateClassName?: string;
    className?: string;
}

const ListWrapper: React.FC<PropsWithChildren<Props>> = ({
    ToolBarComponent = Toolbar,
    noResultsLabel,
    emptyStateClassName,
    className,
    children,
}) => {
    const intl = useContext(IntlContext);
    const { isLoading, data, hasError, error } = useContext(ListContext);

    if (hasError) {
        throw error;
    }

    return (
        <div className={cn("crud_list relative", className)}>
            {isLoading && (
                <Backdrop>
                    <Loader inline message={intl.formatMessage("generic.loading")} />
                </Backdrop>
            )}
            <div className={"crud_list__container"}>{children}</div>
            {!isLoading && data.length === 0 && (
                <div className={emptyStateClassName ?? "no-results"} aria-live="polite">
                    {noResultsLabel ?? intl.formatMessage("generic.label.no_results")}
                </div>
            )}
            {data.length > 0 && ToolBarComponent && <ToolBarComponent />}
        </div>
    );
};

export default ListWrapper;
